var dfs = require("./dfs");

module.exports = preorder;

function preorder(g, vs) {
  return dfs(g, vs, "pre");
}



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/lib/alg/preorder.js
// module id = 121
// module chunks = 0